import * as R from 'ramda';

const initialConnectionState = {
  id: '',
  name: '',
  shortName: '',
  bearerToken: '',
  color: 'rgb(255, 163, 164)',
};

const initialState = {
  byId: {},
  draftsById: {},
  keyWindows: [],
};

export const fetchConnections = keyWindow => ({
  type: 'FETCH_CONNECTIONS',
  payload: {
    keyWindow,
  },
});

export const fetchLastConnection = keyWindow => ({
  type: 'FETCH_LAST_CONNECTION',
  payload: {
    keyWindow,
  },
});

export const deleteConnection = (keyWindow, id) => ({
  type: 'DELETE_CONNECTION',
  payload: {
    keyWindow,
    id,
  },
});

export const saveConnection = (keyWindow, data) => ({
  type: 'SAVE_CONNECTION',
  payload: {
    keyWindow,
    data,
  },
});

export const createConnection = (keyWindow, data) => ({
  type: 'CREATE_CONNECTION',
  payload: {
    keyWindow,
    data,
  },
});

export const editConnection = (id, props) => ({
  type: 'EDIT_CONNECTION',
  payload: {
    id,
    props,
  },
});

export const undoEditConnection = (id) => ({
  type: 'UNDO_EDIT_CONNECTION',
  payload: {
    id,
  },
});

export const receiveConnections = (keyWindow, connections) => {
  return ({
    type: 'RECEIVE_ENTITIES',
    payload: {
      keyWindow,
      entities: {
        connections: {
          byId: R.indexBy(R.prop('id'), connections),
          ids: R.pluck('id')(connections),
        },
      },
    },
  })
};

const connectionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'FETCH_LAST_CONNECTION':
    case 'FETCH_CONNECTIONS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: true,
        },
      };
    case 'EDIT_CONNECTION': {
      return {
        ...state,
        draftsById: {
          ...state.draftsById,
          [action.payload.id]: {
            ...state.draftsById[action.payload.id],
            ...action.payload.props,
          },
        },
      };
    }
    case 'UNDO_EDIT_CONNECTION': {
      return {
        ...state,
        draftsById: {
          ...R.omit([action.payload.id], state.draftsById),
        },
      };
    }
    case 'RECEIVE_ENTITIES':
      return {
        ...state,
        byId: {
          ...state.byId,
          ...R.path(['payload', 'entities', 'connections', 'byId'], action),
        },
        draftsById: {
          ...R.omit(R.pathOr([], ['payload', 'entities', 'connections', 'ids'], action), state.draftsById),
        },
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
          ids: R.path(['payload', 'entities', 'connections', 'ids'], action),
        },
      };
    case 'RECEIVE_ERRORS':
      return {
        ...state,
        keyWindows: [...new Set([...state.keyWindows, action.payload.keyWindow])],
        [action.payload.keyWindow]: {
          ...state[action.payload.keyWindow],
          isLoading: false,
        },
      };
    default:
      return state;
  }
};

export default connectionReducer;
